var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isKyc
        ? _c("ConfigBox", {
            attrs: {
              formIsInvalid: _vm.$v.recipient.$invalid,
              callback: _vm.save,
              title: _vm.$t("recipients.details.box.recipient_identification"),
              hideEditButton: true,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c("RecipientBasicData", {
                        attrs: { recipient: _vm.recipient, canEdit: false },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3180930535
            ),
          })
        : _c("ConfigBox", {
            attrs: {
              formIsInvalid: _vm.$v.recipient.$invalid,
              callback: _vm.save,
              title: _vm.$t("recipients.details.box.recipient_identification"),
              hideEditButton: true,
            },
            scopedSlots: _vm._u([
              {
                key: "content",
                fn: function () {
                  return [
                    _c("Identification", {
                      attrs: {
                        recipient: _vm.recipient,
                        default_bank_account: _vm.default_bank_account,
                        vuelidate: _vm.$v,
                        canEdit: false,
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
      _c("ConfigBox", {
        attrs: {
          hideEditButton: _vm.hideInfoEditButton,
          callback: _vm.save,
          title: _vm.$t("recipients.details.box.info"),
          hasPassword: true,
          mfaNeeded: !_vm.hasUserTwoFactorAuthentication,
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("Recipient", {
                  attrs: {
                    kyc: _vm.isKyc,
                    canSearchZipCode: _vm.canSearchZipCode,
                    recipient: _vm.recipient,
                    vuelidate: _vm.$v,
                    isCpf: _vm.isCpf,
                    locks: _vm.locks,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }